








import {
  Component, Prop, Watch, Vue,
} from 'vue-property-decorator';
import { warn } from 'vue-class-component/lib/util';

@Component
export default class ExamTimer extends Vue {
  @Prop({ default: 0 })
  time: number;

  @Prop({ default: 0 })
  notificationSec: number;

  @Prop({ default: false })
  timerStart: boolean;

  @Watch('timerStart')
  switch() {
    if (this.timerStart) {
      this.start();
      return;
    }
    this.stop();
  }

  /**
   * 分
   */
  min = 0 ;

  /**
   * 秒
   */
  sec = 0;

  /**
   * 制限時間強調フラグ
   */
  isNotification = false;

  /**
   * 実行中タイマー
   */
  timer: number;

  start() {
    clearInterval(this.timer);
    if (this.time > 0) {
      this.min = Math.trunc(this.time / 60);
      this.sec = this.time % 60;
      this.timer = window.setInterval(this.countDown, 1000);
    } else {
      this.$emit('forceEnd');
    }
  }

  stop() {
    clearInterval(this.timer);
    this.$emit('end');
  }

  countDown() {
    if (this.min === 0 && this.sec === 0) {
      this.stop();
      return;
    }

    if (this.sec === 0) {
      this.min -= 1;
      this.sec = 59;
    } else {
      this.sec -= 1;
    }

    const notificationMin = this.notificationSec / 60;
    if ((this.min === notificationMin && this.sec === 0)
    || this.min < notificationMin) {
      this.isNotification = true;
    }
  }

  secFormat = (sec: number) => {
    const strSec = `00${sec}`;
    return strSec.substring(strSec.length - 2, strSec.length);
  }
}
